import RouteContainer from "./routeContainer/RouteContainer";
import { BrowserRouter } from "react-router-dom";
import "./css/base.scss";
import ExperienceRatingModal from "./component/ExperenceRatingModal";
import FirstLoginUpgradeModal from "./component/FirstLoginUpgradeModal";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <RouteContainer />
      <ExperienceRatingModal />
      <FirstLoginUpgradeModal />
    </BrowserRouter>
  );
}

export default App;
